<template>
  <div>
    <div class="btn-group mb-4 mt-3">
      <BaseButton
          type="dark"
          :outline="selectedTab !== 'Leaderboard'"
          @click="selectTab('Leaderboard')"
          :active="selectedTab === 'Leaderboard'"
      >
        Leaderboard
      </BaseButton>
      <BaseButton
          type="dark"
          :outline="selectedTab !== 'AssistantSetup'"
          @click="selectTab('AssistantSetup')"
          :active="selectedTab === 'AssistantSetup'"
      >
        Configurer les assistants
      </BaseButton>
    </div>

    <AssistantSetup
        v-if="selectedTab === 'AssistantSetup'"
        @redirect_assistant_detail="show_assistant_detail"
        :selected_assistant_uid="selected_assistant_uid"
    />

    <Leaderboard
        v-if="selectedTab === 'Leaderboard'"
        @redirect_assistant_detail="show_assistant_detail"
        :selected_assistant_uid="selected_assistant_uid"
    />
  </div>
</template>

<script>
import AssistantSetup from '@/components/AssistantSetup.vue';
import Leaderboard from '@/components/Leaderboard.vue';
import BaseButton from "@/components/ui/BaseButton.vue";

export default {
  name: 'TabPage',
  components: {
    BaseButton,
    AssistantSetup,
    Leaderboard
  },
  data() {
    return {
      tabs: ['Leaderboard', 'Configurer les assistants'],
      selectedTab: 'Leaderboard',
      selected_assistant_uid: null
    };
  },
  methods: {
    selectTab(tab) {
      this.selectedTab = tab;
    },
    show_assistant_detail(uid) {
      console.log(uid);
      this.selected_assistant_uid = uid;
      this.selectTab('AssistantSetup');
    }
  }
};
</script>


<style scoped>
.tabs {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
}

.tabs ul {
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.tabs li {
  flex: 1;
  text-align: center;
  cursor: pointer;
}

.tabs li a {
  display: block;
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: #555;
  font-weight: bold;
  border-bottom: 2px solid transparent;
  transition: color 0.3s, border-bottom-color 0.3s;
}

.tabs li.is-active a {
  color: #7777FF; /* Couleur de l'onglet actif */
  border-bottom-color: #7777FF; /* Couleur de la bordure de l'onglet actif */
}

.tabs li:hover a {
  color: #7777FF; /* Couleur de survol */
}

.tab-content {
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
}
</style>
